<template lang="html">
  <footer id="footer">
    <section class="top-section">
      <div class="container med-container">
  			<div class="row">
  				<div class="col-lg-5 col-left text-center text-lg-left">
  					<!-- <p class="mb-4 mb-lg-3 text-center text-lg-left">
  						<router-link class="btn-logo" to="/">
  							<img src="public/images/logo-white.png" alt="Empaques Tonalá">
  						</router-link>
  					</p> -->
            <!-- <h5 class="f-w-600 text-center text-lg-left">PPI</h5> -->
						<h6 class="f-w-600">Dirección</h6>
            <p class="mb-2 mb-lg-3" v-html="$root.contactInfo.address"></p>

	          <h6 class="f-w-600">Teléfonos de oficina</h6>
            <p class="mb-2 mb-lg-3" v-html="$root.contactInfo.telefono"></p>

            <h6 class="f-w-600">Horarios</h6>
            <p v-html="$root.contactInfo.schedule"></p>

  					<div class="row">
  						<div class="col-sm-6 col-footer">
  							<!-- <p>
  								<router-link to="/comunicados">Comunicados</router-link>
  							</p> -->
  						</div>
  					</div>
  				</div>

  				<div class="col-lg-7 mt-4 mt-lg-0 col-footer col-right">
            <b-form @submit="onSubmit">
              <b-form-group class="custom-f-group-s1">
                <b-form-input
                  v-model="formNewsletter.email"
                  type="email"
                  placeholder="INSCRIBETE A NUESTRO NEWSLETTER"
                  required
                ></b-form-input>
              </b-form-group>
              <b-button type="submit" class="btn-send"></b-button>
            </b-form>

            <div class="row mt-4">
              <div class="col-sm-6">
								<p>
                  <router-link to="/blog">Blog</router-link>
                </p>
                <p>
                  <router-link to="/contacto">Contacto</router-link>
                </p>
                <p>
                  <router-link to="/preguntas-frecuentes">Preguntas frecuentes</router-link>
                </p>
  							<p>
                  <router-link to="/terminos-y-condiciones">Términos y condiciones</router-link>
                </p>
  							<p>
                  <router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>
                </p>
                <p>
                  <router-link to="/condiciones-y-clausula-de-afiliaciones">Condiciones y Clausula de Afiliaciones</router-link>
                </p>
              </div>

              <div class="col-sm-6 mt-3 mt-sm-0 text-center text-sm-right">
                <div class="box-networks">
                  <a class="t-150 btn-network fb" target="_blank" v-if="$root.contactInfo.facebook" :href="$root.contactInfo.facebook"><i class="fab fa-facebook-f"></i></a>
									<!-- <a class="t-150 btn-network tw" href=""><i class="fa-brands fa-x-twitter"></i></a> -->
                  <a class="t-150 btn-network ig" v-if="$root.contactInfo.instagram" :href="$root.contactInfo.instagram"><i class="fab fa-instagram"></i></a>
									<!-- <a class="t-150 btn-network tt" href=""><i class="fa-brands fa-tiktok"></i></a> -->
                  <!-- <a class="t-150 btn-network wa" href=""><i class="fa-brands fa-whatsapp"></i></a> -->
                  <!-- <a class="t-150 btn-network lk" target="_blank" href=""><i class="fab fa-linkedin-in"></i></a> -->
									<a class="t-150 btn-network yt" target="_blank" v-if="$root.contactInfo.youtube" :href="$root.contactInfo.youtube"><i class="fa-brands fa-youtube"></i></a>
                </div>

                <h6 class="title">© Feros {{ currentYear }}</h6>
                <!-- <span class="address">
                  Calle 123
                </span> -->

                <!-- <span class="mt-2 copyright">© Feros {{ currentYear }}</span> -->
              </div>
            </div>
          </div>
  			</div>
    	</div>
    </section>

    <!-- WhatsApp -->
    <a class="ic-glob-whatsapp" target="_blank" :href="'https://wa.me/'+$root.onlyNumbers($root.contactInfo.whatsapp)"><i class="fab fa-whatsapp"></i></a>
    <!--  -->

  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: 0,

      formNewsletter: {
        email: '',
      },
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
  },

  beforeMount() {
    this.currentYear = new Date().getFullYear();
  },
}
</script>
